<template>
<Layout :footer-style="2">
  <div class="SuccessCases">
    <div class="SuccessCases_content">
      <div class="staticBanner">
        <div class="staticimg">
          <h4 class="staticimg-title" >成功案例故事</h4>
          <p class="staticimg-content ">在各行各业，让进步发生</p>
        </div>
        <seamlescroll  class="d-none d-lg-block"></seamlescroll>
      </div>
      <div class="container title">
        <div class="in_titles_left">
          <img class="in_titles_left_img" src="../assets/images/industry/tb.png" alt="">
          <div><span style="margin-right: 10px;">&gt;</span><span style="font-size: 18px;">成功案例故事</span></div>
        </div>
      </div>
      <div class="content_body container">
        <div class="SuccessCases_text rn-section-gap" data-aos="fade-up">
          <div class="fs-1 text-center text-one">博信诚云正在成为各行各业的业财融合数字化专家</div>
          <div class="fs-3 text-center text-two">超过500+大型集团企业和2000+成长型企业业财融合的共同选择</div>
        </div>
        <div class="SuccessCases_card">
          <ListCard :demo-pages="demoPages" :demo-class="demoClass"></ListCard>
        </div>
      </div>
    </div>
  </div>
</Layout>
</template>
<style lang="scss">
.SuccessCases{
  margin: 0 auto;
  max-width: 1920px;
  .SuccessCases_content{
    margin-top: 80px;
    .staticBanner {
      position: relative;
      max-width: 1920px;
      max-height:670px;
      overflow: hidden;
      background: url("../assets/images/casesimg/successCases-new.jpg");
      .staticimg {  
        position: absolute;
        top: 33%;
        left: 13%;
      }
    }
    .title{
      .in_titles_left{
        display: flex;
        align-items: center;
        margin-top: -45px;
        position: absolute;
        left: 13%;
        img{
          margin-right: 10px;
        }
      }
    }
    .content_body{
      .SuccessCases_text{
        color: #12294f;
      }
      .SuccessCases_card{
        background: #fbfbfb;
        padding: 0 10px;
        border-radius: 10px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
<script>
import Layout from '../components/common/Layout'
import ListCard from "@/components/common/relatedCases/listCard"
import seamlescroll from '@/components/common/seamlescroll/index.vue'
export default {
  name: "SuccessCases",
  components: { ListCard,Layout,seamlescroll },
  data() {
    return {
      demoPages: [
        {
          url: "/success-detail/1",
          image: require("@/assets/images/casesimg/guolv-new.png"),
          imageLight: require("@/assets/images/casesimg/guolv-new.png"),
          title: "中国国旅",
          content: "全球化财务共享中心管理",
        },
        {
          url: "/success-detail/2",
          image: require("@/assets/images/casesimg/botian-new.png"),
          imageLight: require("@/assets/images/casesimg/botian-new.png"),
          title: "博天环境 ",
          content: "智慧业财新共享平台",
        },
        {
          url: "/success-detail/3",
          image: require("@/assets/images/casesimg/shanghai-baoye.png"),
          imageLight: require("@/assets/images/casesimg/shanghai-baoye.png"),
          title: "上海宝冶",
          content: "打造一流的最具竞争优势核心理念",
        },
        {
          url: "/success-detail/4",
          image: require("@/assets/images/casesimg/zhongliang.png"),
          imageLight: require("@/assets/images/casesimg/zhongliang.png"),
          title: "中梁控股集团",
          content: "支持中梁未来3000亿规模发展",
        },
        {
          url: "/success-detail/5",
          image: require("@/assets/images/casesimg/enfei-new.png"),
          imageLight: require("@/assets/images/casesimg/enfei-new.png"),
          title: "中国恩菲",
          content: "财务共享平台加速中国恩菲一路一带",
        },
        {
          url: "/success-detail/6",
          image: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          imageLight: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          title: "中冶置业",
          content: "地产企业业财融合智慧创新管理标杆",
        },
        {
          url: "/success-detail/7",
          image: require("@/assets/images/casesimg/jiaotong.png"),
          imageLight: require("@/assets/images/casesimg/jiaotong.png"),
          title: "中冶交通",
          content: "智能业财管理助力财务管控更高效",
        },
        {
          url: "/success-detail/8",
          image: require("@/assets/images/casesimg/huaxiafenmo.png"),
          imageLight: require("@/assets/images/casesimg/huaxiafenmo.png"),
          title: "华夏粉末冶金",
          content: "业财一体化应用为制造企业转型升级赋能",
        },
        {
          url: "",
          image: require("@/assets/images/casesimg/weichuang-yiliao.png"),
          imageLight: require("@/assets/images/casesimg/weichuang-yiliao.png"),
          title: "微创医疗",
          content: "智慧业财一体化平台",
        },
        {
          url: "",
          image: require("@/assets/images/casesimg/lizhong.png"),
          imageLight: require("@/assets/images/casesimg/lizhong.png"),
          title: "立中集团",
          content: "智慧业财一体化平台",
        },
        {
          url: "",
          image: require("@/assets/images/casesimg/BOE.png"),
          imageLight: require("@/assets/images/casesimg/BOE.png"),
          title: "BOE",
          content: "智慧业财一体化平台",
        },
        {
          url: "",
          image: require("@/assets/images/casesimg/NBTM.png"),
          imageLight: require("@/assets/images/casesimg/NBTM.png"),
          title: "NBTM",
          content: "智慧业财一体化平台",
        },
      ],
      demoClass:'col-lg-3 col-md-6 col-12',
    }
  },
  mounted(){
    this.windowShow()
    
  },
  methods:{
    windowShow(){
      let windowWidth = document.documentElement.clientWidth
      if (windowWidth<676) {
        this.demoPages.splice(8)
        console.log(this.demoPages);
      }
    }
  },
}
</script>
<style scoped></style>
